import { type CSSObject } from '@emotion/react';
import { useTheme } from '@doxyme/ui/theme';
import { useViewport } from '@doxyme/ui/hooks';
import { type ModalProps } from '@doxyme/ui/components/foundations';

type UseStylesReturnType = {
  modalCSS: ModalProps['styles'];
  tabWrapperCSS: CSSObject;
};

export const useInviteViaEmailFreeModalContentStyles =
  (): UseStylesReturnType => {
    const theme = useTheme();
    const { isSmallViewport } = useViewport();

    return {
      modalCSS: {
        ...(!isSmallViewport && {
          submitButton: {
            flex: 'initial',
            minWidth: 'auto',
          },
        }),
      },

      tabWrapperCSS: {
        marginTop: theme.spacing(8),
      },
    };
  };
